import React, { useState, useEffect } from 'react';
import './HomePage.css';
import { Link } from 'react-router-dom';
import NavBar from './NavBar';



const slides = [
  {
    image: '../../../Images/Picture.png',
    quote: 'On a Mission to Show Every Person They Are Loved',
  },
  {
    image: '../../../Images/Madison.png',
    quote: 'Service That Changes the One Who Serves',
  },
];

const stats = [
  { number: '790', label: 'Neighbors Experiencing Homelessness in Madison' },
  { number: '400+', label: 'Students Impacted' },
  { number: '3,150', label: 'Meals Shared' },
];

const cards = [
  {
    image: '../../../Images/Picture2.png',
    title: 'Weekly Operations',
    sub: 'How we make our impact',
    href: '/about/operations',
  },
  {
    image: '../../../Images/Impact2.png',
    title: 'Support Our Mission',
    sub: 'How $25 a month can make a difference',
    href: '/get-involved',
  },
 {
  image: '../../../Images/Pic2.png',
  title: 'Student Testimony',
  sub: 'Hear how students have been impacted',
  href: '/our-impact/testimonies',
},

];

const HomePage = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [transitioning, setTransitioning] = useState(false);
  


  useEffect(() => {
    const timer = setInterval(() => {
      setTransitioning(true);
      setTimeout(() => {
        setCurrentSlide((prev) => (prev + 1) % slides.length);
        setTransitioning(false);
      }, 600);
    }, 5500);
    return () => clearInterval(timer);
  }, []);

  const goToSlide = (i) => {
    if (i === currentSlide) return;
    setTransitioning(true);
    setTimeout(() => {
      setCurrentSlide(i);
      setTransitioning(false);
    }, 600);
  };

  return (
    <>
          <NavBar />


      {/* ── HERO SLIDER ── */}
      <section className="fft-hero">
        <div
          className={`fft-slide-bg ${transitioning ? 'fade-out' : 'fade-in'}`}
          style={{ backgroundImage: `url(${slides[currentSlide].image})` }}
        />
        <div className="fft-hero-overlay" />
        <div className="fft-hero-content">
          <p className="fft-hero-eyebrow">Madison, Wisconsin</p>
          <h1 className={`fft-hero-quote ${transitioning ? 'quote-out' : 'quote-in'}`}>
            {slides[currentSlide].quote}
          </h1>
        </div>
        <div className="fft-slide-dots">
          {slides.map((_, i) => (
            <button
              key={i}
              className={`fft-dot ${i === currentSlide ? 'active' : ''}`}
              onClick={() => goToSlide(i)}
              aria-label={`Slide ${i + 1}`}
            />
          ))}
        </div>
      </section>

      {/* ── STATS ── */}
      <section className="fft-stats">
        <div className="fft-stats-inner">
          {stats.map((s, i) => (
            <div key={i} className="fft-stat">
              <span className="fft-stat-number">{s.number}</span>
              <span className="fft-stat-label">{s.label}</span>
            </div>
          ))}
        </div>
      </section>

      {/* ── PULL QUOTE ── */}
      <section className="fft-pullquote">
        <div className="fft-pullquote-inner">
          <div className="fft-quote-mark">&ldquo;</div>
          <blockquote>Thank you for making me feel human again</blockquote>
          <cite>— A neighbor in Madison</cite>
        </div>
      </section>

      {/* ── OUR WORK ── */}
      <section className="fft-work">
        <div className="fft-work-inner">
          <div className="fft-work-text">
            <h2>Our Work</h2>
            <p>
              In the heart of Madison lives a community often unseen. An estimated 790 of our neighbors
              are experiencing homelessness, many quietly battling depression, addiction, and isolation.
              Food for Thought exists to meet them where they are, with a simple but radical belief:
              every person deserves to feel valued and loved.
            </p>
            <p>
              At the same time, students in college feel the pressure of careers, grades, and personal
              ambitions. Food for Thought invites students to pursue their ambitions while serving
              their neighbors.
            </p>
            <p className="fft-work-tagline">
              This is accomplished the simple way: homemade meals, shared at eye level,
              one conversation at a time.
            </p>
          
          </div>
             
          <div className="fft-work-image">
  <video
    controls
    preload="metadata"
    src="../../../Videos/ImpactVideo.mp4#t=0.5"
    className="fft-work-video"
  >
    Your browser does not support the video tag.
  </video>
  <p className="fft-img-caption">A particularly impacted individual that wanted to share the impact of Food for Thought</p>
</div>
        </div>
      </section>

      {/* ── 3 CARDS ── */}
      <section className="fft-cards-section">
        <div className="fft-cards-grid">
          {cards.map((card, i) => (
            <a key={i} href={card.href} className="fft-card">
              <div
                className="fft-card-img"
                style={{ backgroundImage: `url(${card.image})` }}
              />
              <div className="fft-card-body">
                <h3>{card.title}</h3>
                <p>{card.sub}</p>
                <span className="fft-card-arrow">→</span>
              </div>
            </a>
          ))}
        </div>
      </section>

      {/* ── FOOTER ── */}
      <footer className="fft-footer">
        <div className="fft-footer-inner">
          <div className="fft-footer-brand">
            <h3>Food for Thought</h3>
            <p className="fft-footer-certified">501(c)(3) Certified · Madison, WI</p>
            <div className="fft-footer-socials">
              <a
                href="https://www.instagram.com/food4thoughtmadison/"
                target="_blank"
                rel="noreferrer"
                className="fft-social-link"
              >
                Instagram
              </a>
              <a
                href="https://groupme.com/join_group/100373061/PCqVY82E"
                target="_blank"
                rel="noreferrer"
                className="fft-social-link"
              >
                Join GroupMe
              </a>
            </div>
          </div>

         <div className="fft-footer-links">
  <h4>Navigate</h4>
  <Link to="/about/operations">About Us</Link>
  <Link to="/our-impact">Our Impact</Link>
  <Link to="/gallery">Gallery</Link>
</div>

          <div className="fft-footer-contact">
            <h4>Contact Us</h4>
            <p>Paul Selberg</p>
            <a href="tel:4147502031">414-750-2031</a>
            <a href="mailto:paulselberg1@gmail.com">paulselberg1@gmail.com</a>
          </div>
        </div>
        <div className="fft-footer-bottom">
          <p>© {new Date().getFullYear()} Food for Thought · All Rights Reserved</p>
        </div>
      </footer>
    </>
  );
};

export default HomePage;